var map = {
	"./banana.png": 6884,
	"./crown__type.png": 7138,
	"./ghostface.png": 6274,
	"./grabber.png": 1145,
	"./gun_type_1.png": 7785,
	"./gun_type_2.png": 5479,
	"./gun_type_3.png": 3645,
	"./gun_type_alien.png": 377,
	"./gun_type_ape.png": 3282,
	"./gun_type_bones.png": 6697,
	"./gun_type_celestial.png": 3850,
	"./gun_type_custom.png": 3770,
	"./gun_type_demoness.png": 538,
	"./gun_type_ghost.png": 8039,
	"./gun_type_gold.png": 4260,
	"./gun_type_mummy.png": 4429,
	"./gun_type_rebot.png": 6227,
	"./gun_type_robot.png": 6583,
	"./gun_type_zombie.png": 2057,
	"./hannibal.png": 1014,
	"./jason.png": 3210,
	"./leatherface.png": 1203,
	"./mask__type.png": 7725,
	"./mask_type.png": 254,
	"./michael.png": 2723,
	"./none.png": 6413,
	"./rainbow-border.png": 6149,
	"./santa.png": 1142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9445;